/**
 * @generated SignedSource<<20276d8f61560273eb586750e6b52a49>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddNoteTitle_note$data = {
  readonly id: string;
  readonly isLocked: boolean;
  readonly noteTitle: string;
  readonly stream: {
    readonly displayName: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"MenuItemTooltip_useGetPropsForExternalWorkspaces_note">;
  readonly " $fragmentType": "AddNoteTitle_note";
};
export type AddNoteTitle_note$key = {
  readonly " $data"?: AddNoteTitle_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddNoteTitle_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddNoteTitle_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLocked",
      "storageKey": null
    },
    {
      "alias": "noteTitle",
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MenuItemTooltip_useGetPropsForExternalWorkspaces_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "d9963da923b64703452f5e1f0d7a3dcc";

export default node;
